import { render } from "./Header.vue?vue&type=template&id=e5c719a0"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=e5c719a0&lang=scss"

import exportComponent from "C:\\Users\\elkinc\\Desktop\\ANSV\\Licencias\\AppExamenes\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__